/**
 * The withdraw form's id.
 *
 * The dialog's actions are portalled into the shell's foot band, which takes
 * the submit button OUT of the form's DOM subtree — and a submit button
 * outside its form does nothing unless it names the form. React's event
 * tree does not help here: form submission is the browser's, and the
 * browser goes by the DOM.
 */
export const WITHDRAW_FORM_ID = "withdraw-form";
